// extracted by mini-css-extract-plugin
export default {"body":"aboutWidget-module--body--3hBdC"};